export const ActionTypes = {
    SET_LOGIN:"SET_LOGIN",
    SET_LOGOUT:"SET_LOGOUT",
    SET_CHAPTER_INDEX:"SET_CHAPTER_INDEX",
    SET_LECTURE_INDEX:"SET_LECTURE_INDEX",
};